type PasswordValidationOptions = {
  minLength?: number;
  requireUppercase?: boolean;
  requireLowercase?: boolean;
  requireNumber?: boolean;
  requireSpecialChar?: boolean;
};

const defaultPasswordValidationOptions: Required<PasswordValidationOptions> = {
  minLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSpecialChar: true,
};

export const validatePasswordComplexity = (
  password: string,
  options: PasswordValidationOptions = {},
) => {
  if (!password) {
    return "Поље је обавезно";
  }

  const rules = { ...defaultPasswordValidationOptions, ...options };
  const missingRules: string[] = [];

  if (password.length < rules.minLength) {
    missingRules.push(`најмање ${rules.minLength} карактера`);
  }

  if (rules.requireUppercase && !/[A-Z]/.test(password)) {
    missingRules.push("бар једно велико слово");
  }

  if (rules.requireLowercase && !/[a-z]/.test(password)) {
    missingRules.push("бар једно мало слово");
  }

  if (rules.requireNumber && !/\d/.test(password)) {
    missingRules.push("бар један број");
  }

  if (rules.requireSpecialChar && !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    missingRules.push("бар један специјални карактер");
  }

  if (!missingRules.length) {
    return "";
  }

  return `Лозинка мора да садржи: ${missingRules.join(", ")}.`;
};
